import { FinancialStatementItem } from '../../../../financial-statement/models/common/FinancialStatementItem';
import { FinancialStatementPart } from 'src/app/domain/financial-statement/models/common/FinancialStatementPart';
import { formats, getCell, withCellStyles } from '../../../utils';
import { FinancialStatement } from '../../../../financial-statement/models/common/FinancialStatement';
import { Rows, Row } from '../../../interfaces';
import { CellStyle } from 'xlsx-js-style/types';
import { FsSums } from 'src/app/domain/financial-statement/utils/common/FsSums';

export const getPreparedData = (data: FinancialStatement, headers: string[]): Rows => {
  const newData: Rows = [];
  newData.push(mappedHeaders);
  [data.balanceSheetParts, data.profitLossParts].forEach((parts: FinancialStatementPart[], partNumber) => {
    parts.forEach((part: FinancialStatementPart) => {
      newData.push([getCell({ v: part.partName, s: { font: { bold: true } } })]);
      const partRows = getManyRows(part.financialStatementItems, headers);
      newData.push(...partRows);
      newData.push(getTotalRow(part.sums, headers, part.partName + ' Totals'));
    });
    newData.push(getTotalRow(
      partNumber ? data.profitLossNetTotals : data.balanceSheetNetTotals, headers,
      partNumber ? 'Net Totals' : 'Balance Sheet Check'),
    );
  });
  return newData;
};

const mappedHeaders = (
  [
    '',
    'Item name',
    'Trial balance(original)',
    'Debit adjustment',
    'Credit adjustment',
    'Trial balance(after changes)',
  ]);

export const getManyRows = (items: FinancialStatementItem[], headers: string[]) => {
  const rows: Rows = [];
  const mappedToHeaders = items.map((d) => getNewMapping(d));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(mapped[header]);
    }
    rows.push(row);
  }
  return rows;
};

export const getTotalRow = (sums: FsSums, headers: string[], name: string) => {
  const mapped = getTotalMapping(sums, name);
  const row: Row = [];
  for (const header of headers) {
    row.push(withCellStyles(mapped[header], boldNumToFixed2));
  }
  return row;
};

/* eslint-disable @typescript-eslint/naming-convention */
const getTotalMapping = (sums: FsSums, name: string) => ({
  'Part name': '',
  'Item name': name.toUpperCase(),
  'Trial balance(original)': getCell({ v: sums.sumITP, z: formats.thousandsSeparatorToFixed2, t: 'n' }),
  'Debit adjustment': getCell({ v: sums.manualDebit, z: formats.thousandsSeparatorToFixed2, t: 'n' }),
  'Credit adjustment': getCell({ v: sums.manualCredit, z: formats.thousandsSeparatorToFixed2, t: 'n' }),
  'Trial balance(after changes)': getCell(
    { v: sums.sumITP + sums.manualDebit - sums.manualCredit, z: formats.thousandsSeparatorToFixed2, t: 'n' },
  ),
});

/* eslint-disable @typescript-eslint/naming-convention */
const getNewMapping = (data: FinancialStatementItem) => ({
  'Part name': '',
  'Item name': data.name.toUpperCase(),
  'Trial balance(original)': getCell({ v: data.sums.sumITP, z: formats.thousandsSeparatorToFixed2, t: 'n' }),
  'Debit adjustment': getCell({ v: data.sums.manualDebit, z: formats.thousandsSeparatorToFixed2, t: 'n' }),
  'Credit adjustment': getCell({ v: data.sums.manualCredit, z: formats.thousandsSeparatorToFixed2, t: 'n' }),
  'Trial balance(after changes)': getCell(
    { v: data.sums.sumITP + data.sums.manualDebit - data.sums.manualCredit, z: formats.thousandsSeparatorToFixed2, t: 'n' },
  ),
});

const boldNumToFixed2: CellStyle = {
  font: { bold: true },
  numFmt: formats.thousandsSeparatorToFixed2,
};
